var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey lighten-4"},[_c('CallsDailyCalendar',{attrs:{"showFilters":"","filters":_vm.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }